module.exports = __webpack_public_path__ + "img/NETWORK URL BLACK.ec937271.svg";